import { useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { CollectorQuery, useCollectorQuery } from 'graphql/types';

export const useCollector = (
  id: string
): {
  data: CollectorQuery | undefined;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { loading, data, error } = useCollectorQuery({
    variables: {
      input: id
    },
    fetchPolicy: 'cache-and-network'
  });

  return useMemo(
    () => ({
      loading,
      error,
      data
    }),
    [data, error, loading]
  );
};
